import styled from 'styled-components'

export const PageHeaderAnchor = styled.div`
	display: contents;
`
